import {doStyleOnAllOrderingPages} from "../../blocks/allOrderingProcess";

export class CartSecondStep {
    static EventListeners = {
        // 'ShoptetDOMPageContentLoaded': CartSecondStep.doLoadOnShoptetDOMPageContentLoaded,
    }
    static doLoadOnShoptetDOMPageContentLoaded() {}
    static doLoadOnShoptetDOMPageMoreProductsLoaded() {}
    static doLoadOnShoptetDOMContentLoaded() {}
    static doLoadOnChange() {}
    static async doInit() {
        doStyleOnAllOrderingPages();
        CartSecondStep.doStyleMisc();
        return true;
    }

    static doStyleMisc() {
        $('body').addClass('in-krok-1');

    }
}
